/* eslint-disable */

import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'
import { goldInfo } from '@/api/user'
import { CountUp } from 'countup.js'

var timer = null

// 定時回傳在線心跳 取得當下金幣數量
export function refreshGold(position) {
  if (store.getters.token != null) {
    if (position === 'personal') {
      store.commit('SET_GOLD_INFO', null)
    } else  {
      store.commit('SET_COMMISSION_GOLD', null)
    }

    goldInfo().then(response => {
      store.commit('SET_GOLD_INFO', response.data.data)
      store.commit('SET_GOLD_TOTAL', response.data.data)
      store.commit('SET_MAIN_GOLD', response.data.data)
      store.commit('SET_BONUS_GOLD', response.data.data)
      store.commit('SET_MAIN_POINT', response.data.data)
      store.commit('SET_MAIN_TURNOVER', response.data.data)
      store.commit('SET_POINTS', response.data.data)
      store.commit('SET_COMMISSION_GOLD', response.data.data)
    })
  }
}

// 正式環境線路不同 動態取url
export function getApiUrl() {
  // 決定api url
  if (store.getters.urlInfo.apiUrl) {
    return store.getters.urlInfo.apiUrl
  } else {
    return process.env.VUE_APP_BASE_API
  }
}

export function getEventApiUrl() {
  if (process.env.VUE_APP_EVENT_API === '') {
    return 'https://event.gitpush.vip'
  } else {
    return process.env.VUE_APP_EVENT_API
  }
}

export function getFullDomain() {
  const protocol = window.location.protocol;
  const host = window.location.host;

  return protocol + '//' + host + '/'
}

export function setErrorMessage(response, errors) {
  errors.clear()
  if (response !== undefined && response.status !== undefined && response.status === 406) {
    let lastError = i18n.t('Bao.sorry_for_the_error')
    Object.keys(response.data.data).forEach(key => {
      lastError = response.data.data[key][0]
      errors.add({
        field: key,
        msg: lastError
      })
    })
  }
}

export function toErrorPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/error' }, () => {
  })
}

export function toMaintainPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/maintain' }, () => {
  })
}

export function toForbiddenPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/forbidden' }, () => {
  })
}

export function copyText(message, url) {
  if (navigator.share && detectMob()) {
    // 嘗試分享
    navigator.share({
      title: message,
      url: url,
    })
    .then(() => {
      showNotice(i18n.t('Bao.copy_ok'));
    })
    .catch(error => {
      console.log('Error sharing:', error);
      // 如果分享失敗，改為執行「複製」功能
      copyToClipboard(message);
    });
  } else {
    // 直接複製文字
    copyToClipboard(message);
  }
}

function copyToClipboard(text) {
  var aux = document.createElement('input');
  aux.setAttribute('value', text);
  document.body.appendChild(aux);
  aux.select();
  document.execCommand('copy');
  document.body.removeChild(aux);
  showNotice(i18n.t('Bao.copy_ok'));
}

export function showNotice(message, func, close, isMessageLabel, isUseOKText) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel,
    isUseOKText: isUseOKText === undefined ? false : isUseOKText
  }
  store.commit('SET_NOTICE_MESSAGE', data)
}

export function showRequest(message, func) {
  const data = {
    message: message,
    func: func
  }
  store.commit('SET_REQUEST_MESSAGE', data)
}

export function showAd(img, imgLink, urlOpenType, func, closeFunc) {
  const data = {
    img: img === undefined ? null : img,
    imgLink: imgLink === undefined ? null : imgLink,
    urlOpenType: urlOpenType,
    func: func,
    closeFunc: closeFunc
  }
  store.commit('SET_AD_MESSAGE', data)
}

export function showToast(message, func, close, isMessageLabel) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel
  }
  store.commit('SET_TOAST_MESSAGE', data);
}

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function forceApp(currentRouteName, forceSetting) {
  if ((currentRouteName !== 'Register' && currentRouteName !== 'Share' && currentRouteName !== 'Error' && currentRouteName !== 'Critical') && forceSetting === 1 && detectMob() && !notAppPage()) {
    return true
  } else {
    return false
  }
}

export function newWindows(dataObject) {
  var newWindow = null
  if (dataObject.open_type === 'new') {
    return '_blank'
  }

  if (dataObject.open_type === 'self') {
    return '_self'
  }
}

export async function loadDynamicCss() {
  let currentTheme = localStorage.getItem('theme')
  if (!currentTheme) {
    currentTheme = process.env.VUE_APP_THEME
    localStorage.setItem('theme', currentTheme)
  }
  store.commit('SET_THEME', currentTheme);
  if (window.location.pathname.startsWith('/campaign')) {
    const cssFiles = ['campaign_reset.css', 'style_special_deposit.css']
    await Promise.all(cssFiles.map(file => import('@/assets/' + currentTheme + '/css/campaign/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/match/DailyAttend')) {
    const cssFiles = ['event-bonus.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_gold/css/dailyAttend/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/affiliate')) {
    const cssFiles = ['proxy_style.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_gold/minor_css/proxy/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/championship')) {
    const cssFiles = ['championship.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_gold/css/' + file)))
    return;
  } else {
    const cssFiles = ['reset.css', 'main.css','footer.css']
    await Promise.all(cssFiles.map(file => import('@/assets/' + currentTheme + '/css/' + file)))
    await import('@/assets/' + currentTheme + '/css/style.css')
  }

}

export function handleTokenUrl(urlString, token) {
  const url = new URL(urlString)
  const params = new URLSearchParams(url.search)
  params.delete('token')
  if (token) {
    params.append('token', token)
  } else {
    params.append('token', '')
  }
  return `${url.origin}${url.pathname}?${params.toString()}`
}

export function getSumFloatNum(dataList, resultDigit) {
  const maxDecimalLength = Math.max(...dataList.map(numStr => (numStr.split('.')[1] || '').length))
  const sum = dataList.reduce((total, numStr) => {
      const [integerPart, decimalPart] = numStr.split('.')
      const paddedDecimalPart = (decimalPart || '').padEnd(maxDecimalLength, '0')
      return total + parseInt(integerPart + paddedDecimalPart)
  }, 0)
  const sumWithDecimal = (sum / Math.pow(10, maxDecimalLength)).toFixed(resultDigit)

  return sumWithDecimal
}

export function setCurrencySymbol() {
  let currency = process.env.VUE_APP_CURRENCY
  if (currency === 'JPY') {
    store.commit('SET_CURRENCY', '¥')
  } else {
    store.commit('SET_CURRENCY', '$')
  }
}

export function isCrossDay(currentTimeStamp, storedTimeStamp) {
  const currentDay = new Date(currentTimeStamp * 1000).getDate();
  const storedDay = new Date(storedTimeStamp * 1000).getDate();
  return currentDay !== storedDay; // false代表還是同一天
}

export function getThemeImagePath(imageName) {
  const theme = store.getters.currentTheme
  if (theme === 'theme_gold') {
    return require(`@/assets/theme_gold/images/${imageName}`)
  } else {
    return require(`@/assets/theme_gold/images/${imageName}`)
  }
}

// 检查 LiveChat 是否可用
export function isLiveChatAvailable() {
  return typeof LiveChatWidget !== 'undefined' && LiveChatWidget !== null;
}

// 設置 LiveChatWidget 用戶資料
export function setLiveChatWidget(username, email) {
  if (!isLiveChatAvailable()) {
    console.warn('LiveChat is not available');
    return;
  }

  try {
    LiveChatWidget.call('set_customer_name', username);
    LiveChatWidget.call('set_customer_email', email);
    LiveChatWidget.call('maximize');
  } catch (error) {
    console.warn('LiveChat operation error:', error);
  }
}

// 設置 LiveChatWidget Session Variables
export function setSessionVariables(user, userInfo, vipInfo, dateFormatter) {
  const {
    is_pass_KYC,
    first_deposit_amount,
    second_deposit_amount,
    third_deposit_amount,
    birthday,
    vip_last_updated_at,
    last_withdrawal_amount,
    last_withdrawal_updated_at,
    name,
    vl
  } = userInfo;

  const kycStatusMap = {
    0: 'KYC_NONE',
    1: 'KYC_PASS',
    2: 'KYC_PROGRESS',
  };

  const isPassKYC = kycStatusMap[is_pass_KYC];

  LiveChatWidget.call('set_session_variables', {
    kyc: isPassKYC,
    dep1: first_deposit_amount,
    dep2: second_deposit_amount,
    dep3: third_deposit_amount,
    vip: vipInfo.currentVipName,
    birthday,
    vip_last_updated_at: vip_last_updated_at === 0 ? 0 : dateFormatter(vip_last_updated_at),
    last_withdrawal_amount,
    last_withdrawal_updated_at: last_withdrawal_updated_at === 0 ? 0 : dateFormatter(last_withdrawal_updated_at),
    name: name,
    main_balance: user.mainGold,
    bonus_balance: user.bonusGold,
    risk: vl
  });
}

// 處理 HelpCenter 的連結邏輯
export function handleHelpCenterLink(isGuest, banner, user, userInfo, vipInfo, dateFormatter) {
  let formattedLink = banner.link ? banner.link : banner.url;

  if (isGuest) {
    if (banner.open_type === '_iframe') {
      setLiveChatWidget('guest', 'guest@katsuwin.io');
    } else {
      const url = new URL(formattedLink);
      formattedLink = `${url.origin}${url.pathname}`;
      window.open(formattedLink, banner.open_type);
    }
  } else {
    const { username, email, is_pass_KYC, first_deposit_amount, second_deposit_amount, third_deposit_amount } = userInfo;

    if (banner.open_type === '_iframe') {
      setSessionVariables(user, userInfo, vipInfo, dateFormatter);
      setLiveChatWidget(username, email);
    } else {
      const encodedUsername = encodeURIComponent(username);
      const encodedEmail = encodeURIComponent(email);
      const kycStatusMap = {
        0: 'KYC_NONE',
        1: 'KYC_PASS',
        2: 'KYC_PROGRESS',
      };
      const kycStatus = kycStatusMap[is_pass_KYC];

      formattedLink = formattedLink
        .replace('{NAME}', encodedUsername)
        .replace('{EMAIL}', encodedEmail)
        .replace('&amp;', '&')
        .replace('{K}', kycStatus)
        .replace('{D}', `${first_deposit_amount},${second_deposit_amount},${third_deposit_amount}`);
      window.open(formattedLink, banner.open_type);
    }
  }
}

export function initializeCountUp(elementId, value, options = {}) {
  if (!elementId || !value) return;

  const defaultOptions = {
    useEasing: true,
    useGrouping: true,
    separator: '',
    decimal: ',',
    suffix: '',
    startVal: 0,
    duration: 2.5,
  };
  const mergedOptions = { ...defaultOptions, ...options };
  const demo = new CountUp(elementId, value, mergedOptions);

  if (!demo.error) {
    demo.start();
  } else {
    console.error(demo.error);
  }
}

export function updateCountUp(elementId, newValue, options) {
  initializeCountUp(elementId, newValue, options);
}